import * as React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    type?: "button" | "submit";
    color?: "primary" | "secondary" | "warning" | "danger" | "success" | "inverse" | "link";
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    additionalClassName?: string;
    disabled?: boolean;
}

export default class Button extends React.PureComponent<Props> {

    render() {
        return (
            <button
                {...this.props}
                type={this.props.type || "button"}
                className={`btn btn-${this.props.color || "secondary"} btn-${this.props.size} ${this.props.additionalClassName || " "}`}
            >
                {this.props.children}
            </button>
        );
    }
}